let result;

export const getCompareImages = () => {
  if (result) return Promise.resolve(result);
  return import('./widget-compare-images').then((module) => {
    result = module;
    return module;
  });
};